import { useEffect, useRef } from 'react';

interface EmojiClickDetail {
  unicode?: string;
}

/**
 * The web `emoji-picker-element` custom element wrapper. Registers the element
 * lazily on mount (keeping it out of the initial bundle until first shown) and
 * forwards `emoji-click` events to `onPick`. Used only by {@link EmojiPicker}.
 */
export function EmojiPickerElement({ onPick }: { onPick: (emoji: string) => void }) {
  const ref = useRef<HTMLElement | null>(null);

  // Register the custom element once, lazily (also keeps it out of the initial
  // bundle until the picker is first mounted on this screen).
  useEffect(() => {
    void import('emoji-picker-element');
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<EmojiClickDetail>).detail;
      if (detail?.unicode) onPick(detail.unicode);
    };
    el.addEventListener('emoji-click', handler);
    return () => el.removeEventListener('emoji-click', handler);
  }, [onPick]);

  return <emoji-picker ref={ref} />;
}
